import { render } from "./fallback-circle.vue?vue&type=template&id=48dd43e6&scoped=true"
import script from "./fallback-circle.vue?vue&type=script&lang=js"
export * from "./fallback-circle.vue?vue&type=script&lang=js"

import "./fallback-circle.vue?vue&type=style&index=0&id=48dd43e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dd43e6"]])

export default __exports__